import { useState } from "react";
import DialogFormPanel from "../../../../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../../../../shared/components/button/CreateButtonTrigger";
import CreateClientCampaignForm from "./CreateClientCampaignForm";

const CreateClientCampaignDialog = ({ onSubmitHandler }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="clients.detail.tabs.campaigns.createForm.title"
      description="clients.detail.tabs.campaigns.createForm.description"
      content={<CreateClientCampaignForm onSubmitHandler={onSubmit} />}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateClientCampaignDialog;
